import axios from '@axios'

const PREFIX_RECURSO = '/recursos'

const PREFIX = '/telas-favoritas'

export default {
  getRecursos() {
    return axios.get(`${PREFIX_RECURSO}`)
  },

  salvarTela(recurso, id) {
    return axios.post(`${PREFIX}/usuario/${id}`, recurso)
  },

  getTelasFavoritas(id) {
    return axios.get(`${PREFIX}/usuario/${id}`)
  },

  deletarTela(id) {
    return axios.delete(`${PREFIX}/tela/${id}`)
  },
}
